import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { NewsType, Comment, FollowableUser, Tag } from 'js/social/shared/types';
import toSnakecaseKeys from 'js/utils/toSnakecaseKeys';

export const createComment = async (
  content: string,
  tags: Tag[],
  commentableId: number | string,
  commentableType: NewsType,
  parentCommentId?: number | string,
) => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_comment_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content,
        tags: tags.map(toSnakecaseKeys),
        [`${commentableType}_id`]: commentableId,
        parent_comment_id: parentCommentId,
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to create comment');
  }
  const payload: { comment: Comment; user: FollowableUser } =
    await response.json();
  return payload;
};

export const deleteComment = async (commentId: number | string) => {
  // Spammers get rate-limited "spoofed" comments with ID 0
  if (!commentId) return;

  const response = await fetchWithCsrf(
    routes.api_v0_community_comment_path({
      subdomain_param: 'api',
      id: commentId,
    }),
    { method: 'DELETE' },
  );
  if (response.status !== 204) {
    throw new Error('Failed to delete comment');
  }
};

export const reportComment = async (
  postId: number | string,
  reason?: string,
) => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_report_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        social_item_id: postId,
        social_item_type: 'comment',
        reason: 'other',
        free_text_reason: reason,
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to report comment');
  }
};

export const createPaperUpdateAndComment = async (
  content: string,
  tags: Tag[],
  workId: number | string,
) => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_create_paper_update_and_add_comment_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content,
        tags: tags.map(toSnakecaseKeys),
        work_id: workId,
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to create comment');
  }
  const payload: {
    news_type: NewsType;
    news_id: number | string;
    comment: Comment;
    user: FollowableUser;
  } = await response.json();
  return payload;
};
